// removed by extract-text-webpack-plugin
module.exports = {"canvas":"Canvas__canvas"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Canvas/Canvas.css
// module id = 1346
// module chunks = 8